import { SET_REPORT } from "./actionTypes";
import { EmbedResult } from "../../model/EmbedResult";

export const setReportAction = (report: EmbedResult[]) => {
    return {
        type: SET_REPORT,
        payload: report
    };
} 
